import { useState, useEffect } from 'react';
import { useUIStore, useDataStore } from '../stores';
import './CreateProjectModal.css';

function LinkClientModal() {
  const isOpen = useUIStore(state => state.modals.linkClient);
  const closeModal = useUIStore(state => state.closeModal);
  const linkProjectClient = useDataStore(state => state.linkProjectClient);
  const showSuccessNotification = useUIStore(state => state.showSuccessNotification);
  const showErrorNotification = useUIStore(state => state.showErrorNotification);
  const clients = useDataStore(state => state.clients);
  const projects = useDataStore(state => state.projects);

  const [selectedClientId, setSelectedClientId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const selectedProjectId = useUIStore(state => state.selectedProjectId);
  const project = projects.find(p => p.id === selectedProjectId);

  // Reset form when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setSelectedClientId('');
      setError('');
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedClientId) {
      setError('Please select a client');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await linkProjectClient(selectedProjectId, parseInt(selectedClientId));
      showSuccessNotification('Project linked with client successfully');
      closeModal('linkClient');
      useUIStore.getState().setSelectedProjectId(null);
    } catch (err) {
      console.error('Error linking project with client:', err);
      let errorMessage = 'Failed to link project with client';
      if (err.data && err.data.message) {
        errorMessage = err.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }
      setError(errorMessage);
      showErrorNotification(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      closeModal('linkClient');
      useUIStore.getState().setSelectedProjectId(null);
      setSelectedClientId('');
      setError('');
    }
  };

  if (!isOpen || !project) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Link Project with Client</h3>
          <button 
            className="modal-close" 
            onClick={handleClose}
            disabled={isSubmitting}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="project-form">
          <div className="form-group">
            <label>Project</label>
            <input
              type="text"
              value={project.project_title}
              disabled
              className="disabled-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="client_id">Select Client *</label>
            <select
              id="client_id"
              name="client_id"
              value={selectedClientId}
              onChange={(e) => {
                setSelectedClientId(e.target.value);
                setError('');
              }}
              className={error ? 'error' : ''}
              disabled={isSubmitting}
            >
              <option value="">-- Select a client --</option>
              {clients.map(client => (
                <option key={client.id} value={client.id}>
                  {client.name} ({client.phone})
                </option>
              ))}
            </select>
            {error && <span className="error-text">{error}</span>}
            {clients.length === 0 && (
              <span className="info-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
                No clients available. Please create a client first.
              </span>
            )}
          </div>

          <div className="form-actions">
            <button 
              type="button" 
              onClick={handleClose}
              className="btn-secondary"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn-primary"
              disabled={isSubmitting || !selectedClientId || clients.length === 0}
            >
              {isSubmitting ? 'Linking...' : 'Link Client'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LinkClientModal;

